import { render, staticRenderFns } from "./SolicitudesInscripcionesLayout.vue?vue&type=template&id=1dc15468&scoped=true"
import script from "./SolicitudesInscripcionesLayout.vue?vue&type=script&lang=js"
export * from "./SolicitudesInscripcionesLayout.vue?vue&type=script&lang=js"
import style0 from "./SolicitudesInscripcionesLayout.vue?vue&type=style&index=0&id=1dc15468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc15468",
  null
  
)

export default component.exports